// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HXYp3","content":"styles_content__2U8s_","row":"styles_row__3pZAA","footer":"styles_footer__pb1wW","phraseLength":"styles_phraseLength__1sG6z"};